/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Rows_AllInputs */

const en_tl_rows_all = /** @type {(inputs: Tl_Rows_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All dated`)
};

const de_tl_rows_all = /** @type {(inputs: Tl_Rows_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle mit Termin`)
};

/**
* | output |
* | --- |
* | "All dated" |
*
* @param {Tl_Rows_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_rows_all = /** @type {((inputs?: Tl_Rows_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Rows_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_rows_all(inputs)
	return en_tl_rows_all(inputs)
});